module.exports = __webpack_public_path__ + "static/media/Software Companes.092f2cc6.svg";